import { EventBus } from "@/lib/event-bus";

const state = {
	items: [],
	plans: [],
};

const getters = {
	inCart: (state) => (item) => {
		return state.items.some(_item => _item.id === item.id);
	},
	payableAmount(state) {
		return state.items.reduce((sum, item) => (+item.plan.upfront_amount * item.plan.quantity) + sum, 0);
	},
	schedule(state) {
		const total = state.items.reduce((acc, item) => {
			return acc + (item.plan.monthly_amount * item.plan.no_of_months * item.plan.quantity);
		}, 0);
		const months = state.items.reduce((max, item) => {
			return max < item.plan.no_of_months ? item.plan.no_of_months : max
		}, 0);
		return Array(months).fill(0).reduce((acc, v, i) => {
			const today = new Date(Date.now());
			const month = today.getMonth() + i + 1 < 12 ? today.getMonth() + i + 1 : (today.getMonth() + i + 1) - 12
			const year = today.getMonth() < month ? today.getFullYear() : today.getFullYear() + 1;
			const date = new Date(year, month, today.getDate());
			acc.push({
				date,
				serial: `${ i + 1 }`,
				amount: parseFloat((total / months).toFixed(2))
			})
			return acc;
		}, []);
	},
	eligibility(state) {
		return state.items.some(item => item.data_option === 1);
	},
	repayment: (state) => {
		const total = state.items.reduce((acc, item) => {
			if (item.plan.monthly_amount && item.plan.no_of_months) {
				return acc + (item.plan.monthly_amount * item.plan.no_of_months * item.plan.quantity);
			}
			return acc;
		}, 0);
		const total_estimate = state.items.reduce((acc, item) => {
			if (item.plan.monthly_amount_estimate && item.plan.no_of_months) {
				return acc + (item.plan.monthly_amount_estimate * item.plan.no_of_months * item.plan.quantity);
			}
			return acc;
		}, 0);
		const months = state.items.reduce((max, item) => {
			return max < item.plan.no_of_months ? item.plan.no_of_months : max
		}, 0);
		return {
			total,
			monthly: total ? total / months : 0,
			monthly_estimate: total_estimate ? total_estimate / months : 0,
			months
		}
	}
};

const mutations = {
	addItem: (state, item) => {
		const exists = state.items.some(_item => _item.id === item.id);
		if (exists) {
			state.items = state.items.map(_item => {
				if (_item.id === item.id) {
					return { ..._item, plan: { ...item.plan, quantity: item.plan.quantity } };
				}
				return _item;
			});
		} else {
			state.items.push(item);
		}
	},
	increaseQuantity: (state, id) => {
		state.items = state.items.map(item => {
			if (item.id === id) item.plan.quantity = Math.min((item.maximum_order || 10), item.plan.quantity + 1, item.quantity || 1)
			return item;
		});
	},
	decreaseQuantity: (state, id) => {
		state.items = state.items.map(item => {
			if (item.id === id) item.plan.quantity = Math.max(1, item.plan.quantity - 1)
			return item;
		});
	},
	removeItem: (state, id) => {
		state.items = state.items.filter(item => item.id !== id);
	},
	clear() {
		state.items = []
		state.plans = []
	}
};

const actions = {
	show() {
		EventBus.$emit('cart')
	}
};

const cart = {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};

export default cart;
